import { ISortQuery } from './ISortQuery';

export interface ISortQueryRequest {
  sortBy?: string;
}

export const convertFromISortQueryToISortQueryRequest = ({ sortField, sortOrder }: ISortQuery): ISortQueryRequest => ({
  sortBy: sortField && sortOrder ? `${sortField}.${sortOrder}` : undefined,
});
